import { FunctionComponent, useEffect, useRef } from 'react';
import PriceCard, { HEIGHT_CHECK_CLASSNAME } from './PriceCard';
import { Price } from './types';

type PriceCardsProps = {
  prices: Price[];
};

const PriceCards: FunctionComponent<PriceCardsProps> = ({ prices }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const handleResize = (entries: ResizeObserverEntry[]) => {
      let maxHeight = 0;
      for (const entry of entries) {
        const node = entry.target as HTMLElement;
        node.querySelectorAll(`.${HEIGHT_CHECK_CLASSNAME}`).forEach((elt) => {
          const h = (elt as HTMLElement).offsetHeight;
          if (h > maxHeight) {
            maxHeight = h;
          }
        });
        node.style.setProperty('--height-check', `${maxHeight}px`);
      }
    };

    const observer = new ResizeObserver(handleResize);
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current]);

  return (
    <div
      ref={ref}
      className="space-y-4 lg:flex lg:items-stretch lg:justify-center lg:gap-6 lg:space-y-0"
    >
      {prices.map((p) => (
        <PriceCard key={p.id} price={p} className="lg:w-[312px]" />
      ))}
    </div>
  );
};

PriceCards.displayName = 'PriceCards';

export default PriceCards;
